<template>
    <div class="card card-default">
        <div class="card-header">
            Update Estimated Number Throughput
        </div>
        <div class="card-body" >
            <!-- Success Message -->
            <div class="alert alert-success" v-if="successful">
                Your estimated number throughput settings have been updated!
            </div>

            <form role="form">
                <!-- 10 DLC SMS -->
                <div class="form-group row" :class="{'has-error': form.throughput10DLCSMS.errors}">
                    <label class="col-md-4 col-form-label text-md-right">10DLC SMS MPS</label>
                    <div class="col-md-6" >
                        <input type="number" class="form-control" name="10dlc_sms" v-model="form.throughput10DLCSMS.value" :class="{'is-invalid': form.throughput10DLCSMS.errors}">
                        <span class="help-block" v-show="form.throughput10DLCSMS.errors">
                            {{ form.throughput10DLCSMS.errors }}
                        </span>
                    </div>
                </div>

                <!-- 10 DLC MMS -->
                <div class="form-group row" :class="{'has-error': form.throughput10DLCMMS.errors}">
                    <label class="col-md-4 col-form-label text-md-right">10DLC MMS MPS</label>
                    <div class="col-md-6" >
                        <input type="number" class="form-control" name="10dlc_mms" v-model="form.throughput10DLCMMS.value" :class="{'is-invalid': form.throughput10DLCMMS.errors}">
                        <span class="help-block" v-show="form.throughput10DLCMMS.errors">
                            {{ form.throughput10DLCMMS.errors }}
                        </span>
                    </div>
                </div>

                <!-- Tollfree SMS -->
                <div class="form-group row" :class="{'has-error': form.throughputTFSMS.errors}">
                    <label class="col-md-4 col-form-label text-md-right">Tollfree SMS MPS</label>
                    <div class="col-md-6" >
                        <input type="number" class="form-control" name="tf_sms" v-model="form.throughputTFSMS.value" :class="{'is-invalid': form.throughputTFSMS.errors}">
                        <span class="help-block" v-show="form.throughputTFSMS.errors">
                            {{ form.throughputTFSMS.errors }}
                        </span>
                    </div>
                </div>

                <!-- Tollfree MMS -->
                <div class="form-group row" :class="{'has-error': form.throughputTFMMS.errors}">
                    <label class="col-md-4 col-form-label text-md-right">Tollfree MMS MPS</label>
                    <div class="col-md-6" >
                        <input type="number" class="form-control" name="tf_mms" v-model="form.throughputTFMMS.value" :class="{'is-invalid': form.throughputTFMMS.errors}">
                        <span class="help-block" v-show="form.throughputTFMMS.errors">
                            {{ form.throughputTFMMS.errors }}
                        </span>
                    </div>
                </div>

                <!-- Update Button -->
                <div class="form-group row mb-0">
                    <div class="offset-md-4 col-md-6">
                        <button type="submit" class="btn btn-primary"
                                @click.prevent="update"
                                :disabled="busy">
                            Update
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import teamThroughputClient from '../../../../services/teamThroughputClient';

export default {
    props: ['team'],

    data() {
        return {
            busy: false,
            successful: undefined,
            form: {
                throughput10DLCSMS: {
                    value: '',
                    errors: ''
                },
                throughput10DLCMMS: {
                    value: '',
                    errors: ''
                },
                throughputTFSMS: {
                    value: '',
                    errors: ''
                },
                throughputTFMMS: {
                    value: '',
                    errors: ''
                },
            }
        };
    },

    mounted() {
        this.busy = true;

        teamThroughputClient.list(this.team.id).then(({data}) => {
            this.form.throughput10DLCSMS.value = data.data.find(t => t.throughput_type === '10dlc_sms').throughput_rate
            this.form.throughput10DLCMMS.value = data.data.find(t => t.throughput_type === '10dlc_mms').throughput_rate
            this.form.throughputTFSMS.value = data.data.find(t => t.throughput_type === 'tf_sms').throughput_rate
            this.form.throughputTFMMS.value = data.data.find(t => t.throughput_type === 'tf_mms').throughput_rate
        }).finally(() => {
            this.busy = false;
        })
    },

    methods: {
        update() {
            this.busy = true;

            this.form.throughput10DLCSMS.errors = ''
            this.form.throughput10DLCMMS.errors = ''
            this.form.throughputTFSMS.errors = ''
            this.form.throughputTFMMS.errors = ''

            const promise10DLCSMS = teamThroughputClient.store(this.team.id, '10dlc_sms', this.form.throughput10DLCSMS.value);
            const promise10DLCMMS = teamThroughputClient.store(this.team.id, '10dlc_mms', this.form.throughput10DLCMMS.value);
            const promiseTFSMS = teamThroughputClient.store(this.team.id, 'tf_sms', this.form.throughputTFSMS.value);
            const promiseTFMMS = teamThroughputClient.store(this.team.id, 'tf_mms', this.form.throughputTFMMS.value);

            Promise.all([
                promise10DLCSMS.catch((error) => { this.form.throughput10DLCSMS.errors = error.response?.data?.message }),
                promise10DLCMMS.catch((error) => { this.form.throughput10DLCMMS.errors = error.response?.data?.message }),
                promiseTFSMS.catch((error) => { this.form.throughputTFSMS.errors = error.response?.data?.message }),
                promiseTFMMS.catch((error) => { this.form.throughputTFMMS.errors = error.response?.data?.message }),
            ]).then(responses => {
                this.successful = !responses.includes(undefined)
            }).finally(() => {
                this.busy = false;
            })
        },
    },
};
</script>
